function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#0d0e0e;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-74.54 -73.89)"
}, /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M87.769,76l11.357,7.613V98.478H76.3V83.613L87.769,76m0-2.109L74.54,82.678v17.56h26.347V82.677L87.769,73.89Z",
  transform: "translate(0)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "a",
  width: 19.345,
  height: 1.721,
  transform: "translate(77.984 84.482)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "a",
  width: 19.345,
  height: 1.721,
  transform: "translate(77.984 93.29)"
})));

function SvgIconDefault(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.347,
    height: 26.348,
    viewBox: "0 0 26.347 26.348",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDefault);
export default __webpack_public_path__ + "static/media/IconDefault.f7eb5496ae0fa7ca8d733baad13ffe91.svg";
export { ForwardRef as ReactComponent };